export default {
      id: "minus-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#minus-usage",
      toString: function () {
        return this.url;
      }
    }